// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3JTGx","text":"SelectPayment_text__23oTK","title":"SelectPayment_title__2lTye","btn":"SelectPayment_btn__1FpBr"};